export const DYNAMIC_ONLINE_HEADER_LABELS = [
  { id: 0, title: 'Computer' },
  { id: 1, title: 'WiFi Network' },
  { id: 2, title: 'Streaming Device' },
  { id: 3, title: 'Printer' },
  { id: 4, title: 'Home Theater' },
];
